import {
  B_FLOW_ID,
  C_B_FLOW_ID,
  C_FLOW_ID,
  C_PL_FLOW_ID,
  PL_B_FLOW_ID,
  PL_FLOW_ID,
  TRIPLE_FLOW_ID,
} from '../boilerplate/item-ids';

/**
 * Transformer that requests a new item when the user clicks on `remove product`.
 * Also sets some flows incompleted since one of the products is removed.
 */
export default (kasko) => {
  kasko.addEventListener('state-changed', (state) => {
    if (state.input.is_remove_item_modal !== 'remove_item') {
      return;
    }
    const requestedItemId = state.input.request_item_id;
    const currentItemId = state.item?.data?.id;
    const setNewInput = (redirectTo, itemsObject) => {
      kasko.dispatchEvent('request-item', {
        item_id: requestedItemId,
      });

      kasko.dispatchEvent('set-state-input', {
        request_item_id: '',
        screen_removal_redirection: redirectTo,
        screen_removal_redirection_from: currentItemId,
        ...itemsObject,
      });
    };

    if (currentItemId === C_PL_FLOW_ID) {
      if (requestedItemId === C_FLOW_ID) {
        setNewInput('private-liability-start', {
          private_liability_finished: false,
          item_A: true,
          item_B: false,
          item_C: false,
          item_A_B: false,
          item_A_C: false,
          item_B_C: false,
          item_A_B_C: false,
        });
      }

      if (requestedItemId === PL_FLOW_ID) {
        setNewInput('start', {
          contents_finished: false,
          item_A: false,
          item_B: true,
          item_C: false,
          item_A_B: false,
          item_A_C: false,
          item_B_C: false,
          item_A_B_C: false,
        });
      }
    }

    if (currentItemId === C_B_FLOW_ID) {
      if (requestedItemId === C_FLOW_ID) {
        setNewInput('buildings-start', {
          buildings_finished: false,
          item_A: true,
          item_B: false,
          item_C: false,
          item_A_B: false,
          item_A_C: false,
          item_B_C: false,
          item_A_B_C: false,
        });
      }

      if (requestedItemId === B_FLOW_ID) {
        setNewInput('start', {
          contents_finished: false,
          item_A: false,
          item_B: false,
          item_C: true,
          item_A_B: false,
          item_A_C: false,
          item_B_C: false,
          item_A_B_C: false,
        });
      }
    }

    if (currentItemId === PL_B_FLOW_ID) {
      if (requestedItemId === B_FLOW_ID) {
        setNewInput('private-liability-start', {
          private_liability_finished: false,
          item_A: false,
          item_B: false,
          item_C: true,
          item_A_B: false,
          item_A_C: false,
          item_B_C: false,
          item_A_B_C: false,
        });
      }

      if (requestedItemId === PL_FLOW_ID) {
        setNewInput('buildings-start', {
          buildings_finished: false,
          item_A: false,
          item_B: true,
          item_C: false,
          item_A_B: false,
          item_A_C: false,
          item_B_C: false,
          item_A_B_C: false,
        });
      }
    }

    if (currentItemId === TRIPLE_FLOW_ID) {
      if (requestedItemId === C_PL_FLOW_ID) {
        setNewInput('buildings-start', {
          buildings_finished: false,
          item_A: false,
          item_B: false,
          item_C: false,
          item_A_B: true,
          item_A_C: false,
          item_B_C: false,
          item_A_B_C: false,
        });
      }

      if (requestedItemId === C_B_FLOW_ID) {
        setNewInput('private-liability-start', {
          private_liability_finished: false,
          item_A: false,
          item_B: false,
          item_C: false,
          item_A_B: false,
          item_A_C: true,
          item_B_C: false,
          item_A_B_C: false,
        });
      }

      if (requestedItemId === PL_B_FLOW_ID) {
        setNewInput('start', {
          contents_finished: false,
          item_A: false,
          item_B: false,
          item_C: false,
          item_A_B: false,
          item_A_C: false,
          item_B_C: true,
          item_A_B_C: false,
        });
      }
    }
  });
};
